import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { BannersGridType } from '../../../utils/bannersGridTypes';
import context from '../context';
import Banners from './Banners';
import Form from './Form';

// O tipo vive aqui (e não no Form) para a aba Banners acompanhar a troca antes do Salvar.
const BannersGrid: React.FC = () => {
  const { pageGroup } = useContext(context);
  const [tabIndex, setTabIndex] = useState(0);
  const [tipoSelecionado, setTipoSelecionado] = useState<
    BannersGridType | undefined
  >(pageGroup?.type);

  useEffect(() => {
    setTipoSelecionado(pageGroup?.type);
  }, [pageGroup?.type]);

  return (
    <Tabs index={tabIndex} onChange={index => setTabIndex(index)}>
      <TabList>
        <Tab>Dados</Tab>
        <Tab isDisabled={!pageGroup}>Banners</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Form
            onCreated={() => setTabIndex(1)}
            onTypeChange={setTipoSelecionado}
          />
        </TabPanel>
        <TabPanel>
          <Banners type={tipoSelecionado} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default BannersGrid;
